<template>
  <div id="form-ingreso">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">Curso RBD</v-toolbar-title>
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md12>
            <!-- INICIO DATOS DE REVISION -->
            <template>
              <v-form ref="form" v-model="validacion" lazy-validation>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      v-model="regionValue"
                      :error-messages="regionErrors"
                      label="Region"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.regionValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.regionValue.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="nivelValue"
                      :error-messages="nivelErrors"
                      label="Nivel"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.nivelValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.nivelValue.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="tipoValue"
                      :error-messages="tipoErrors"
                      label="Tipo"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.tipoValue.$touch()"
                      @blur="tipeView == 'crear' ? $v.tipoValue.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="rbdCantidadValue"
                      :error-messages="tipoErrors"
                      label="RBD Cantidad"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.rbdCantidadValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.rbdCantidadValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="rbdAplicadosValue"
                      :error-messages="tipoErrors"
                      label="RBD Aplicados"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.rbdAplicadosValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.rbdAplicadosValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="rbdEmergentesValue"
                      :error-messages="tipoErrors"
                      label="RBD Emergentes"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.rbdEmergentesValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.rbdEmergentesValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="rbdNoAplicadosValue"
                      :error-messages="tipoErrors"
                      label="RBD No Aplicados"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.rbdNoAplicadosValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.rbdNoAplicadosValue.$touch()
                          : null
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <v-text-field
                      v-model="rbdPorcentajeAplicacionValue"
                      :error-messages="tipoErrors"
                      label="RBD % Aplicacion"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.rbdPorcentajeAplicacionValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.rbdPorcentajeAplicacionValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="cursosCantidadValue"
                      :error-messages="tipoErrors"
                      label="CURSOS Cantidad"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cursosCantidadValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.cursosCantidadValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="cursosAplicadosValue"
                      :error-messages="tipoErrors"
                      label="CURSOS Aplicados"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cursosAplicadosValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.cursosAplicadosValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="cursosEmergentesValue"
                      :error-messages="tipoErrors"
                      label="CURSOS Emergentes"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cursosEmergentesValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.cursosEmergentesValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="cursosNoAplicadosValue"
                      :error-messages="tipoErrors"
                      label="CURSOS No Aplicados"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cursosNoAplicadosValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.cursosNoAplicadosValue.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="cursosPorcetajeAplicacionValue"
                      :error-messages="tipoErrors"
                      label="CURSOS % Aplicacion"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cursosPorcetajeAplicacionValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.cursosPorcetajeAplicacionValue.$touch()
                          : null
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <!-- TERMINO DATOS DE REVISION-->
          </v-flex>
          <v-flex xs12 md1></v-flex>
        </v-layout>
        <!-- --------------------------------------------- -->
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="tipeView == 'crear' || tipeView == 'modifica'"
            :loading="loading"
            color="primary"
            @click="save()"
          >
            Guardar
            <v-icon right dark>save</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { error } from "util";
import { misMixins } from "@/mixins/myMixing.js";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "FormIngreso",
  components: {
    AlertEmpty,
  },
  mixins: [misMixins, validationMixin],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      alertaRecibidos: false,
      dialog: false,
      visibleNew: false,
      userlogged: "",
      regionValue: "",
      nivelValue: "",
      tipoValue: "",
      rbdCantidadValue: "",
      rbdAplicadosValue: "",
      rbdEmergentesValue: "",
      rbdNoAplicadosValue: "",
      rbdPorcentajeAplicacionValue: "",
      cursosCantidadValue: "",
      cursosAplicadosValue: "",
      cursosEmergentesValue: "",
      cursosNoAplicadosValue: "",
      cursosPorcetajeAplicacionValue: "",
      vNumeroRegistroValue: "",
      idIngreso: "",
      ingreso: [],
    };
  },

  validations: {},

  created() {
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.titleView = this.$route.params.titleView;
    this.idContrato = this.$store.getters.contratoStored;

    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta") {
      this.idIngreso = this.$route.params.idIngreso;
      this.userlogged = this.$store.getters.userLogged.tipo;
      this.loadData();
    }
    if (this.tipeView == "crear") {
    }

    if (this.userlogged == "PROVEEDOR") {
      this.visibleNew = true;
    } else {
      this.visibleNew = false;
    }
  },
  mounted() {},
  computed: {},
  methods: {
    async loadCentrosRegion() {
      await this.loadCentrosAcopio();
      await this.loadCentrosOperacion();
    },

    async loadData() {
      this.ingreso = await this.loadIngresoData();
      this.regionValue = this.ingreso.idRegion.nombre;
      this.nivelValue = this.ingreso.idNivel.descripcion;
      this.tipoValue = this.ingreso.idTipoAplicacion.descripcion;
      this.rbdCantidadValue = this.ingreso.cantidadRBD;
      this.rbdAplicadosValue = this.ingreso.cantidadRbdAplicados;
      this.rbdEmergentesValue = this.ingreso.rbdEmergentes;
      this.rbdNoAplicadosValue = this.ingreso.rbdNoAplicados;
      this.rbdPorcentajeAplicacionValue = this.ingreso.porcentajeAplicados;
      this.cursosCantidadValue = this.ingreso.cursosCantidad;
      this.cursosAplicadosValue = this.ingreso.cursosAplicados;
      this.cursosEmergentesValue = this.ingreso.cursosEmergentes;
      this.cursosNoAplicadosValue = this.ingreso.cursosNoAplicados;
      this.cursosPorcetajeAplicacionValue =
        this.ingreso.cursosPorcentajeAplicacion;
    },

    async loadIngresoData() {
      var that = this;
      return await axios
        .get(
          "/reporte6A/getReporteAById/" + this.idIngreso + "/" + this.idContrato
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
